import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { Button, Checkbox, Chip, Collapse, Dialog, DialogContent, Divider, FormControl, Grid, InputLabel, LinearProgress, List, ListItem, ListItemText, MenuItem, Select, Switch, TextField, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { IMAGE_INTEGRATIONS, BLOG_INTEGRATIONS, ROWS_PER_PAGE, VIDEO_INTEGRATIONS } from '../../utils/constant';
import Confirmation from '../Common/Confirmation';
import { fetchCookies, generateCookie, deleteCookie, cookieToggleActivation } from '../../store/cookieSlice';
import CookieForm from '../Cookie/CookieForm';
import { NoData } from '../Common/NoData';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import * as Yup from "yup";
import { useFormik } from 'formik';
import DialogTitle from '@mui/material/DialogTitle';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { approveAIContent, deleteAIContent, fetchAIContents, rejectAIContent, reuploadContent } from '../../store/aiContentSlice';
import blog from '../../assets/blog.png';
import { formatDate } from '../../utils/helper';
import ReactMarkdown from 'react-markdown';
import AIContentForm from './aiContent/AIContentForm';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { fetchDomainList, fetchDomains } from '../../store/domainSlice';
import { Editor, EditorProvider } from 'react-simple-wysiwyg';
import MarkDownEditor from '../Common/MarkDownEditor';
import BasicPopover from '../Common/PopOver';
import RefreshIcon from '@mui/icons-material/Refresh';
import { UploadFileOutlined, UploadOutlined } from '@mui/icons-material';


function createData(id, source, type, status, isApproved, expireAt, actions, mediaUrl, title,
    description, createdAt, caption, context) {
    return {
        id,
        source,
        type,
        status,
        isApproved,
        expireAt,
        actions,
        mediaUrl,
        title,
        description,
        createdAt,
        caption,
        context
    };
}

const AIContentManageActions = ({ page, setPage, getCookies, cookie, getAIContentData, setAIContentModal, selectedContent, setSelectedContent, canDelete, canEdit, canAdd }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [openApprove, setOpenApprove] = React.useState(false);
    const [rejectOpen, setRejectOpen] = React.useState(false);
    const [integration, setIntegration] = React.useState([]);
    const [openRegenerate, setOpenRegenerate] = React.useState(false);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const videoIntegrations = VIDEO_INTEGRATIONS?.map((ele) => ele.key);
    const domains = useSelector((state) => state.domainReducer.domainList);
    const availableIntegration = IMAGE_INTEGRATIONS?.map((ele) => ele.key);
    const blogIntegration = BLOG_INTEGRATIONS?.map((ele) => ele.key);
    const [allIntegrationNames, setAllIntegrationNames] = React.useState();

    const dispatch = useDispatch()
    const allOptionId = 'all';
    const allLabel = 'All';
    const getIntegrationsByMediaType = (mediaType) => {
        switch (mediaType) {
            case 'video':
                // setAllIntegrationNames(videoIntegrations);
                return VIDEO_INTEGRATIONS;
            case 'image':
                // setAllIntegrationNames(availableIntegration);
                return IMAGE_INTEGRATIONS;
            case 'blog':
                // setAllIntegrationNames(blogIntegration);
                return BLOG_INTEGRATIONS;
            default:
                return [];
        }
    }

    const setAvailableIntegrations = (mediaType) => {

        switch (mediaType) {
            case 'video':
                setAllIntegrationNames(videoIntegrations);
                break
            // return VIDEO_INTEGRATIONS;
            case 'image':
                setAllIntegrationNames(availableIntegration);
                break
            // return IMAGE_INTEGRATIONS;
            case 'blog':
                setAllIntegrationNames(blogIntegration);
                break
            // return BLOG_INTEGRATIONS;
            default:
                return [];
        }
    }
    // const allIntegrationNames = IMAGE_INTEGRATIONS?.map((ele) => ele.key);

    const handleDelete = async (id) => {
        try {
            dispatch(deleteAIContent(id)).then(() => {
                getAIContentData()
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleReject = async (id) => {
        try {
            dispatch(rejectAIContent(id)).then(() => {
                getAIContentData()
            })
        } catch (error) {
            console.error(error);
        }
    }

    const validationSchema = Yup.object({
        prompt: Yup.string()

    });

    const formik = useFormik({
        initialValues: {
            password: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsProcessing(true)
            try {

            } catch (error) {
                console.error(error);
            }
        }
    });

    const isActionAllowed = (action, status) => {
        if (action === 'pending') {
            return true;
        } else {
            return false
        }
    }


    return (
        <>
            <Grid spacing={4} justifyContent={'flex-end'}>
                <Grid size={8}>
                    <Box gap={2} display='flex' className="table-margin">
                        <Tooltip title="Approve">
                            <span>
                                <CheckCircleIcon
                                    color={cookie.is_approved ? 'success' : 'action'}
                                    style={{ cursor: !cookie.is_approved ? 'pointer' : 'not-allowed' }}
                                    onClick={() => {
                                        if (!cookie.is_approved) {
                                            setAvailableIntegrations(cookie?.media_type);
                                            setOpenApprove(true)
                                            if (isActionAllowed('approve')) {
                                            }
                                        }
                                    }}
                                />
                            </span>
                        </Tooltip>

                        <Tooltip title="Reject">
                            <span>
                                <CancelIcon
                                    color={cookie.is_rejected ? 'error' : !cookie.is_approved ? 'action' : 'disabled'}
                                    style={{ cursor: !cookie.is_rejected && !cookie.is_approved ? 'pointer' : 'not-allowed' }}
                                    onClick={() => {
                                        if (!cookie.is_approved && !cookie.is_rejected) {
                                            setRejectOpen(true)
                                        }
                                    }}
                                />
                            </span>
                        </Tooltip>

                        {/* 
                        <Tooltip title="Regenerate">
                            <RefreshIcon className={`${!canAdd && 'icon-disabled'}`} color='primary' onClick={() => {
                                if (canAdd) {
                                    setOpenRegenerate(true)
                                }
                            }} />
                        </Tooltip> */}
                        {/* <EditOutlinedIcon className={` 'link-color'}`} color='primary' onClick={(e) => {
                            e.stopPropagation();
                            setAIContentModal(true)
                            setSelectedContent(cookie)

                        }} /> */}
                        <DeleteOutlineOutlinedIcon className={`${!canDelete && 'icon-disabled'} danger-color`} onClick={() => {
                            if (canDelete) {
                                setIsOpen(true)
                            }
                        }} />
                    </Box>
                    <Dialog
                        open={openRegenerate}
                        onClose={() => setOpenRegenerate(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle
                            sx={{
                                m: 0,
                                p: 2,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #e0e0e0",
                            }}
                        >
                            <Typography variant="h6">Regenerate Content</Typography>
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpenRegenerate(false)}
                                sx={{
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',

                            }}
                            className='p-4'
                        >
                            <div className="position-relative w-100 d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                                {/* Image preview */}
                                {cookie?.mediaUrl ? (
                                    cookie.mediaUrl.match(/\.(mp4|webm|ogg)$/i) ? (
                                        <>
                                            <video
                                                controls
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '80vh',
                                                    objectFit: 'contain',
                                                }}
                                            >
                                                <source src={cookie.mediaUrl} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            <Typography variant='body2' className='mt-2'>{cookie?.caption}</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <Typography variant='body2' className='mt-2'>{cookie?.caption}</Typography>
                                            <TransformWrapper>
                                                <TransformComponent>
                                                    <img
                                                        src={cookie.mediaUrl}
                                                        alt="Preview"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '80vh',
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                </TransformComponent>
                                            </TransformWrapper>

                                        </>
                                    )
                                ) : (
                                    <>N/A</>
                                )}
                                {isProcessing && (
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                        style={{
                                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                            zIndex: 1050, // above the image
                                        }}
                                    >
                                        <h5 className="text-white m-0">Processing...</h5>
                                    </div>
                                )}
                            </div>
                        </DialogContent>
                        <Box display="flex" gap={2} alignItems="flex-start" className="p-3">
                            <Box flex={1}>
                                <form onSubmit={formik.handleSubmit}>
                                    <TextField
                                        label="Prompt (Optional)"
                                        name="prompt"
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        value={formik.values.prompt}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.prompt && Boolean(formik.errors.prompt)}
                                        helperText={formik.touched.prompt && formik.errors.prompt}
                                    />
                                </form>
                            </Box>

                            <Box display="flex" flexDirection="column" gap={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    // size="small"
                                    disabled={isProcessing}
                                    onClick={formik.handleSubmit}
                                >
                                    Regenerate
                                </Button>
                            </Box>
                        </Box>

                    </Dialog>

                    <Dialog
                        open={openApprove}
                        onClose={() => setOpenApprove(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle
                            sx={{
                                m: 0,
                                p: 2,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #e0e0e0",
                            }}>
                            <Typography variant="h6">Content Approve </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpenApprove(false)}
                                sx={{
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <AIContentForm title={"Content Approve"} getAIContentData={getAIContentData} type={cookie.media_type} aicontent={cookie} aiContentModal={openApprove} setAIContentModal={setOpenApprove} allIntegrationNames={allIntegrationNames} setAllIntegrationNames={setAllIntegrationNames} selectedContent={cookie} />

                        </DialogContent>
                    </Dialog>

                    <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to remove this Media"} yesClick={() => { handleDelete(cookie.uuid); setIsOpen(false) }} />
                    <Confirmation open={rejectOpen} setOpen={setRejectOpen} msg={"Are you sure you want to Reject this Content"} yesClick={() => { setRejectOpen(false); handleReject(cookie.uuid); }} />
                </Grid>
            </Grid>
        </>
    )
}

const headCells = [

    {
        label: 'Category',
        numeric: false,
        disablePadding: false,
        id: 'Context',
        sortable: false
    },
    {
        label: 'Content Type',
        numeric: false,
        disablePadding: false,
        id: 'content_type',
        sortable: false
    },
    {
        label: 'Content',
        numeric: false,
        disablePadding: false,
        id: 'content',
        sortable: false
    },
    {
        label: 'Generated At',
        numeric: false,
        disablePadding: false,
        id: 'generated_at',
        sortable: false
    },
    {
        label: 'Status',
        numeric: false,
        disablePadding: false,
        id: 'status',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: false,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState } =
        props;

    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {

            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)
    };

    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }

    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";

                    return (<TableCell
                        className="font-weight"
                        key={key}
                        align={headCell.numeric ? "left" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={isSorted ? sortDirection : false}
                    >
                        {headCell.sortable ? <TableSortLabel
                            active={isSorted}
                            direction={sortDirection}
                            onClick={createSortHandler(key)}
                            color="secondary"
                            hideSortIcon={false}
                        >
                            {headCell.label}
                            {isSorted && (
                                <Box component="span" sx={visuallyHidden}>
                                    {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                            {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                        </TableSortLabel> : headCell.label}
                    </TableCell>)
                })}

            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { cookieModal, page, setPage, getCookies, setCookieModal, selecteCookie, setSelecteCookie, setResetTrigger, resetTrigger } = props;
    return (
        <>
            <CookieForm {...{ page, setPage, getCookies, cookieModal, setCookieModal, setSelecteCookie, selecteCookie, resetTrigger }} title={selecteCookie ? "Edit" : "Create"} />
            <Toolbar
                className='main-list-toolbar'
            >
                <Typography
                    className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    AI Content
                </Typography>
            </Toolbar>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const statusIcons = {
    approved: <CheckCircleIcon fontSize="small" style={{ color: 'green' }} className='mr-1' />,
    rejected: <CancelIcon fontSize="small" style={{ color: 'red' }} className='mr-1' />,
};

export default function AIContentManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [cookieModal, setCookieModal] = React.useState(false);
    const [aiContentModal, setAIContentModal] = React.useState(false);
    const [selecteCookie, setSelecteCookie] = React.useState({});
    const [selectedContent, setSelectedContent] = React.useState({});
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const [queryString, setQueryString] = React.useState("");
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const aiContents = useSelector((state) => state.aiContentReducer.aiContents)
    const loading = useSelector((state) => state.aiContentReducer.loading)
    const cookieCount = useSelector((state) => state.aiContentReducer.count)
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const cookiePermissions = userPermission.find((perm) => perm.model_name === "leads")?.permissions || [];
    // let canEdit = cookiePermissions.includes("change");
    let canEdit = true
    // let canDelete = cookiePermissions.includes("delete");
    let canDelete = true
    let canAdd = cookiePermissions.includes("add");
    const [orderingState, setOrderingState] = React.useState([])
    const [ordering, setOrdering] = React.useState('-updated_at');
    const dispatch = useDispatch()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const label = { inputProps: { 'aria-label': 'Color switch demo' } };

    React.useEffect(() => {
        setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering}`)
    }, [ordering, page, rowsPerPage])

    const handleReupload = (uuid) => {
        dispatch(reuploadContent({ uuid })).then(() => {
            getAIContentData()
        })
    }
    const handleupload = (uuid, source) => {
        dispatch(approveAIContent({ uuid, integration: [source] })).then(() => {
            getAIContentData()
        })
    }

    const getAIContentData = () => {
        dispatch(fetchAIContents(queryString))
    }

    React.useEffect(() => {
        getAIContentData()
    }, [queryString])

    React.useEffect(() => {
        const rowData = aiContents?.map((ele) => {
            return {
                ...createData(ele.uuid, ele.sources, ele.media_type, ele?.status, ele.is_approved, ele?.expire_at,
                    <AIContentManageActions {...{ page, setPage, getAIContentData, setSelectedContent, aiContentModal, setAIContentModal, selectedContent, cookieModal, canAdd, setCookieModal, setSelecteCookie, canDelete, canEdit }} cookie={ele} />, ele.media_url),
                mediaUrl: ele.media_url,
                title: ele.title,
                description: ele.formatted_body,
                createdAt: ele.created_at,
                caption: ele?.formatted_caption,
                context: ele?.category,
            }
        })

        setRows(rowData)
    }, [aiContents, loading])

    function Row(props) {
        const { row, labelId } = props;
        const [hovered, setHovered] = React.useState(false);
        const [open, setOpen] = React.useState(false);
        const [contentStatusData, setContentStatusData] = React.useState(row.source || []);
        const [previewOpen, setPreviewOpen] = React.useState(false);

        // Get current source types from the input
        const existingTypes = row?.source.map(s => s.source);
        // Add missing sources
        React.useEffect(() => {
            let constantData = []
            if (row?.source?.length) {
                switch (row.type) {
                    case 'video':
                        VIDEO_INTEGRATIONS.forEach(type => {
                            if (!existingTypes.includes(type.key)) {
                                constantData = [...constantData,
                                {
                                    id: null,
                                    uuid: null,
                                    status: "pending",
                                    source: type.key,
                                    created_at: null
                                }
                                ]
                            }
                        });
                        setContentStatusData([...row.source, ...constantData])

                        break;
                    case 'image':
                        IMAGE_INTEGRATIONS.forEach(type => {
                            if (!existingTypes.includes(type.key)) {
                                console.log("contentStatusData image", type.key);
                                constantData = [...constantData,
                                {
                                    id: null,
                                    uuid: null,
                                    status: "pending",
                                    source: type.key,
                                    created_at: null
                                }
                                ]
                            }
                        });
                        setContentStatusData([...row.source, ...constantData])
                        break;
                    default:
                }
            }

        }, [])


        return (
            <>
                <React.Fragment>
                    <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        id={labelId}
                        className="cursor-pointer"
                    >
                        {/* <TableCell>
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpen(!open)}
                            >
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell> */}
                        <TableCell align="left" className='text-capitalize'>{row.context}</TableCell>

                        <TableCell align="left" className='text-capitalize'>{row.type}</TableCell>
                        <TableCell align="left">
                            <Box
                                className="media-container"
                                onMouseEnter={() => setHovered(true)}
                                onMouseLeave={() => setHovered(false)}
                            >
                                {row.type === "image" ? (
                                    <>
                                        <img
                                            src={row.mediaUrl}
                                            alt="content"
                                            className="media-img"
                                            onClick={() => setPreviewOpen(true)}
                                        />
                                        {hovered && (
                                            <Box className="media-hover-overlay" onClick={() => setPreviewOpen(true)}>
                                                <RemoveRedEyeOutlinedIcon style={{ color: '#fff', fontSize: 28 }} />
                                            </Box>
                                        )}
                                    </>
                                ) : row.type === "video" ? (
                                    <Box onClick={() => setPreviewOpen(true)} className="media-container" style={{ cursor: 'pointer' }}>
                                        <video
                                            src={row.mediaUrl}
                                            className="media-video"
                                            muted
                                            preload="metadata"
                                        />
                                        {hovered && (
                                            <Box className="media-hover-overlay" onClick={() => setPreviewOpen(true)}>
                                                <RemoveRedEyeOutlinedIcon style={{ color: '#fff', fontSize: 28 }} />
                                            </Box>
                                        )}
                                    </Box>
                                ) : (
                                    <>
                                        <img
                                            src={blog}
                                            alt="content"
                                            className="media-img"
                                            onClick={() => setPreviewOpen(true)}
                                        />
                                        {hovered && (
                                            <Box className="media-hover-overlay" onClick={() => setPreviewOpen(true)}>
                                                <RemoveRedEyeOutlinedIcon style={{ color: '#fff', fontSize: 28 }} />
                                            </Box>
                                        )}
                                    </>
                                )}
                            </Box>
                        </TableCell>
                        {/* <TableCell align="left">
                            <Typography color={"primary"} variant='body2' className='text-capitalize'> <span>{row.status || 'N/A'}</span> </Typography>
                        </TableCell> */}
                        <TableCell align="left">
                            <Typography variant='body2' className='text-capitalize'> <span>{formatDate(row.createdAt) || 'N/A'}</span> </Typography>
                        </TableCell>

                        {/* <TableCell align="left">{row.active}</TableCell> */}

                        <TableCell align="left">

                            {row.source?.length >= 1 ? (
                                <BasicPopover

                                    customTrigger={
                                        <Button
                                            size="small"
                                            color='primary'
                                            variant="outlined"
                                        >
                                            {/* {statusIcons[row?.status?.status]} */}
                                            View
                                        </Button>
                                    }
                                    length={contentStatusData?.length - 1}>
                                    <List disablePadding dense className='location-list'>
                                        {contentStatusData?.map((ele, index) => (
                                            <ListItem key={index} disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <Box className="d-flex" justifyContent={"left"} alignItems={"center"}>
                                                            <Typography variant='body2' color={"primary"} className='text-capitalize '> {ele.source}: &nbsp;</Typography>
                                                            <Tooltip title={""} arrow>
                                                                <Typography variant='body2' className='text-capitalize '> {ele.status}</Typography>
                                                            </Tooltip>
                                                            {ele?.status === "failed" && <Tooltip title={"Re-Upload Content"} arrow>
                                                                <IconButton className='px-2 pt-0 pb-0'>
                                                                    <RefreshIcon color='primary' onClick={() => { handleReupload(ele.uuid) }} />
                                                                </IconButton>
                                                            </Tooltip>}
                                                            {ele?.status === "pending" && !ele?.created_at && <Tooltip title={"Upload Content"} arrow>
                                                                <IconButton className='px-2 pt-0 pb-0'>
                                                                    <UploadFileOutlined color='primary' onClick={() => { handleupload(row.id, ele.source) }} />
                                                                </IconButton>
                                                            </Tooltip>}
                                                        </Box>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </BasicPopover>
                            ) : "N/A"
                            }

                        </TableCell>
                        <TableCell align="left">
                            {row.actions}
                        </TableCell>
                    </TableRow>
                    {/* {row?.source?.length ?
                        <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <Box sx={{ marginLeft: 5, marginRight: 5, marginTop: 2, marginBottom: 4 }}>
                                        <Table size="small" aria-label="purchases">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><Typography variant='body1'>Source</Typography></TableCell>
                                                    <TableCell><Typography variant='body1'>Status</Typography></TableCell>
                                                    <TableCell ><Typography variant='body1'>Uploaded On</Typography></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {row.source?.map((sourceData) => (
                                                    <TableRow key={sourceData?.id}>

                                                        <TableCell>{sourceData?.source}</TableCell>
                                                        <TableCell >
                                                            <Typography color={"primary"} variant='body2' className='text-capitalize'> <span>{sourceData?.status || 'N/A'}</span> </Typography>

                                                        </TableCell>
                                                        <TableCell>{formatDate(sourceData?.created_at)}</TableCell>

                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </Collapse>
                            </TableCell>
                        </TableRow> : <></>} */}
                </React.Fragment>
                <Dialog
                    open={previewOpen}
                    onClose={() => setPreviewOpen(false)}
                    maxWidth={`${row?.type === "blog" ? "md" : "sm"}`}
                    fullWidth
                >
                    <DialogTitle
                        sx={{
                            m: 0,
                            p: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #e0e0e0",
                        }}
                    >
                        <Typography variant="h6">Preview</Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setPreviewOpen(false)}
                            sx={{
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <div className="position-relative w-100 justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                            {row?.type === "video" ? (
                                <>
                                    <Box className='mt-3' >
                                        <Typography variant='body2' className='mt-2'>{row?.caption}</Typography>
                                    </Box>
                                    <video
                                        controls
                                        style={{
                                            maxWidth: '100%',
                                            objectFit: 'contain',
                                        }}
                                    >
                                        <source src={row.mediaUrl} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </>
                            ) : row?.type === "image" ? (
                                <>
                                    <Box className='d-flex flex-column align-items-center'>
                                        <Typography variant='body2' className='mt-2'>{row?.caption}</Typography>
                                    </Box>
                                    <TransformWrapper>
                                        <TransformComponent>
                                            <img
                                                src={row.mediaUrl}
                                                alt="Preview"
                                                style={{
                                                    maxWidth: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </TransformComponent>
                                    </TransformWrapper>

                                </>
                            ) : <>
                                <MarkDownEditor row={row} getAIContentData={getAIContentData} />

                                {/* <Box className='mt-3' >
                                    <Typography variant='h5'>{row.title}</Typography>
                                    <ReactMarkdown>{row.description}</ReactMarkdown>

                                </Box> */}
                            </>
                            }
                        </div>
                    </DialogContent>
                </Dialog>
            </>
        );
    }

    return (
        <Box className='w-100'>
            {/* <AIContentForm {...{ aiContentModal, setAIContentModal, selectedContent }} type={selectedContent?.media_type} title={"Edit"} /> */}

            <Confirmation open={opneActiveConfirm} setOpen={setOpneActiveConfirm} msg={"Are you sure you want to inactive this account"} yesClick={() => { dispatch(cookieToggleActivation(selecteCookie.uuid)); setOpneActiveConfirm(false) }} />
            <Paper className="w-100 mb-2" >
                <EnhancedTableToolbar numSelected={selected.length} {...{ page, setPage, cookieModal, setCookieModal, setSelecteCookie, selecteCookie, setResetTrigger, resetTrigger }} />
                {loading && <LinearProgress />}
                <TableContainer className='position-relative'>
                    <Table
                        className='min-width-750'
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            orderingState={orderingState}
                            setOrderingState={setOrderingState}
                            setOrdering={setOrdering}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows?.length}
                        />
                        <TableBody>
                            {rows?.map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <Row row={row} label={labelId} />
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!aiContents?.length && !loading && <NoData></NoData>}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={cookieCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
